import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { HttpClient } from '@angular/common/http';
import { AppToolbarService } from '../../components/toolbar/services/app-toolbar.service';
import { CST_LIST_REFRESH_DISPOTITION, CST_TOOLBAR_BTN_EVENT } from '../../components/toolbar/app-tool-bar/app-tool-bar.component';
import { ArmaServConnection } from 'src/app/classes/info-connection';
import { DataSnapResult } from 'src/app/classes/json-interface';
import { MatSort } from '@angular/material/sort';

@Component({
  selector: 'app-list-facture',
  templateUrl: './list-facture.component.html',
  styleUrls: ['./list-facture.component.css']
})
export class ListFactureComponent implements OnInit {

  HTML_TABLE_HEADER_COL: string[] = ['DOC_NO', 'DOC_DATE', 'DOC_VALUE', 'Action'];
  HTML_TABLE_DATASOURCE: MatTableDataSource<ArmaRestInvoiceList>;

  inProgress: boolean;

  @ViewChild(MatSort, {static: true}) sort!: MatSort;

  constructor(
    private mHttp: HttpClient,
    private mToolbar: AppToolbarService
  ) {
    this.HTML_TABLE_DATASOURCE = new MatTableDataSource<ArmaRestInvoiceList>([]);
    this.inProgress = false;
  }

  ngOnInit() {
    this.mToolbar.toolbarPageTitle = 'Mes factures';
    this.mToolbar.setDisposition(CST_LIST_REFRESH_DISPOTITION);
    this.mToolbar.getObservableClick(true).subscribe(next => this.onToolbarItemClick(next));
    this.mToolbar.getObservableSiteChange().subscribe(next => this.onToolbarSiteChange(next));
    this.loadArrayInvoice();
    this.manageTableSort();
  }

  private manageTableSort() {
    this.HTML_TABLE_DATASOURCE.sort = this.sort;
    this.HTML_TABLE_DATASOURCE.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'DOC_DATE':
          const date = (item[property]).split('/');
          return new Date(+date[2], +date[1], +date[0]);
        case 'DOC_VALUE': return +(item[property]).replace(/\s+|\,+/g, '');
        default:
          // @ts-ignore TODO: TS7053: Element implicitly has an 'any' type
          return item[property];
      }
    };
  }

  private onToolbarItemClick(eventName: string) {
    switch (eventName) {
      case CST_TOOLBAR_BTN_EVENT.Refresh:
        this.loadArrayInvoice();
        break;
    }
  }

  private onToolbarSiteChange(newSiteCode: string) {
    this.loadArrayInvoice();
  }

  public onFilterChange(text: string) {
    this.HTML_TABLE_DATASOURCE.filter = text;
  }

  async loadArrayInvoice() {
    if (!this.inProgress) {
      this.inProgress = true;
      this.HTML_TABLE_DATASOURCE.data = [];
      try {
        const result = await ArmaServConnection.aGET(this.mHttp, 'GetListInvoices', [this.mToolbar.selectedSiteCode]);
        this.HTML_TABLE_DATASOURCE.data = (result as DataSnapResult).result[0];
      } finally {
        this.inProgress = false;
      }
    }
  }

  getInvoice(element: ArmaRestInvoiceList, download: boolean) {
    ArmaServConnection.getPDF(this.mHttp, 'DownloadInvoice', [element.DOC_NO], download, 'Facture n°' + element.DOC_NO + '.pdf');
  }

  downloadAll() {
    ArmaServConnection.downloadFile(this.mHttp, 'DownloadAllInvoices', [], 'Invoices.zip');
  }
}

export interface ArmaRestInvoiceList {
  DOC_NO: string;
  DOC_DATE: string;
  DOC_VALUE: string;
  DOC_CUST_NAME: string;
  DOC_SITE_NAME: string;
}
